var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 138.609 162.169",
    viewBox: "0 0 138.61 162.17",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 11.901v150.27h82.546c28.462-16.295 45.847-38.039 45.847-61.924 0-42.27-54.432-77.838-128.39-88.344zm59.143 132.84c-24.439 0-44.25-19.811-44.25-44.25s19.811-44.25 44.25-44.25 44.25 19.811 44.25 44.25-19.812 44.25-44.25 44.25z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.776c84647e349eab32bb0c3d660021fa.svg";
export { ForwardRef as ReactComponent };